export const onIconEnter = (callback) => callback((prev) => [true, prev[1]]);
export const onIconLeave = (callback) => callback((prev) => [false, prev[1]]);

export const onProfileEnter = (callback) => callback((prev) => [prev[0], true]);
export const onProfileLeave = (callback) =>
  callback((prev) => [prev[0], false]);
